import { FunctionComponent, useEffect, useState } from 'react'
import Modal from '@/components/Modal'
import Icon from '@/components/HeroIcons'
import { Speciality } from '@/modules/MedicalSpecialities/classes/Speciality'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import FooterCancelledModal from '@/modules/RealtimeAttendance/components/FooterCancelledModal/footer-cancelled-modal'
import { useStyles } from './styles'
import { RenderIf } from '@/components/RenderIf'
import { useAttendancePaymentMethod } from '@/modules/MyCalls/store/useAttendancePayment'

const CancelledByTimeModal: FunctionComponent<{
  hookSuccess()
  hookFailed()
  speciality: Speciality
}> = ({ hookSuccess, hookFailed, speciality }) => {
  const [canSchedule, setCanSchedule] = useState<boolean>()
  const { clinic } = useAuthContext()
  const styles = useStyles()

  const attendancePayment = useAttendancePaymentMethod(
    state => state.attendancePayment,
  )

  useEffect(() => {
    if (speciality) setCanSchedule(speciality.canSchedule)
  }, [speciality])

  return (
    <Modal id="CANCELLED_BY_TIME">
      <div>
        <div css={styles.modalWrapper}>
          <RenderIf
            condition={
              clinic?.canPrivateAttendance &&
              attendancePayment !== 'CONSULTA_GRATIS'
            }
          >
            <p>
              Você excedeu o tempo de tolerância de atraso, sua consulta foi
              cancelada automaticamente e o valor será estornado.
            </p>
          </RenderIf>

          <RenderIf
            condition={
              !clinic?.canPrivateAttendance ||
              attendancePayment === 'CONSULTA_GRATIS'
            }
          >
            <p>
              Você excedeu o tempo de tolerância de atraso, sua consulta foi
              cancelada automaticamente.
            </p>
          </RenderIf>

          <div>
            <Icon name="time-canceling-schedule" width="205px" />
          </div>

          <p css={styles.modalQuestionText}>
            Mas fique tranquilo, você poderá solicitar um novo atendimento na
            tela inicial ou agendar uma consulta.
          </p>

          <FooterCancelledModal
            canSchedule={canSchedule}
            hookSuccess={hookSuccess}
            hookFailed={hookFailed}
            buttonNameScheduled="Quero agendar"
            buttonNameImmediate="Ok, entendi"
          />
        </div>
      </div>
    </Modal>
  )
}

export default CancelledByTimeModal
